import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const NameCollectionModal = ({ isOpen, onSubmit, onClose }) => {
  const { user, isAuthenticated } = useAuth();
  const [userName, setUserName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated && user) {
      // Pre-populate with OAuth name if available, otherwise use email prefix
      const defaultName = user.name || user.email?.split('@')[0] || '';
      setUserName(defaultName);
    }
  }, [isAuthenticated, user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmedName = userName.trim();
    
    if (!trimmedName) {
      alert('Veuillez entrer votre nom');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(trimmedName);
    } catch (error) {
      console.error('Error submitting name:', error);
      alert('Erreur lors de la soumission du nom. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '10px',
        boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
        maxWidth: '500px',
        width: '90%'
      }}>
        <h2 style={{
          color: '#2c3e50',
          marginBottom: '1.5rem',
          textAlign: 'center'
        }}>
          👋 Bienvenue !
        </h2>
        
        <p style={{
          color: '#7f8c8d',
          marginBottom: '2rem',
          textAlign: 'center',
          lineHeight: '1.6'
        }}>
          Pour personnaliser votre expérience et vos rapports, veuillez confirmer votre nom :
        </p>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.5rem',
              fontWeight: 'bold',
              color: '#2c3e50'
            }}>
              Nom complet <span style={{ color: '#e74c3c' }}>*</span>
            </label>
            <input
              type="text"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="Entrez votre nom complet"
              required
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '0.75rem',
                border: '2px solid #e9ecef',
                borderRadius: '5px',
                fontSize: '1rem',
                boxSizing: 'border-box',
                transition: 'border-color 0.3s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3498db'}
              onBlur={(e) => e.target.style.borderColor = '#e9ecef'}
            />
            <small style={{
              color: '#7f8c8d',
              fontSize: '0.85rem',
              marginTop: '0.25rem',
              display: 'block'
            }}>
              Ce nom apparaîtra sur vos rapports PDF
            </small>
          </div>

          <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'flex-end'
          }}>
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              style={{
                padding: '0.75rem 1.5rem',
                border: '2px solid #95a5a6',
                backgroundColor: 'transparent',
                color: '#95a5a6',
                borderRadius: '5px',
                cursor: isSubmitting ? 'not-allowed' : 'pointer',
                fontSize: '1rem',
                opacity: isSubmitting ? 0.6 : 1
              }}
            >
              Annuler
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !userName.trim()}
              style={{
                padding: '0.75rem 2rem',
                border: 'none',
                backgroundColor: isSubmitting || !userName.trim() ? '#bdc3c7' : '#3498db',
                color: 'white',
                borderRadius: '5px',
                cursor: isSubmitting || !userName.trim() ? 'not-allowed' : 'pointer',
                fontSize: '1rem',
                fontWeight: 'bold'
              }}
            >
              {isSubmitting ? '⏳ Enregistrement...' : '✅ Continuer'}
            </button>
          </div>
        </form>

        {isAuthenticated && user && (
          <div style={{
            marginTop: '1.5rem',
            padding: '1rem',
            backgroundColor: '#f8f9fa',
            borderRadius: '5px',
            fontSize: '0.9rem',
            color: '#6c757d'
          }}>
            💡 <strong>Info :</strong> Vous êtes connecté avec {user.email}
            {user.provider === 'azure' && ' (compte Azure)'}
            {user.provider === 'anonymous' && ' (accès temporaire)'}
          </div>
        )}
      </div>
    </div>
  );
};

export default NameCollectionModal;